export const passwordRegex =
	/^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{}\[\]|\\;:'",.<>/?]).{8,}$/;

export const multiLineBreakRegex = /\n{2,}/g;
export const multiLineBreakRegex2 = /\\n{2,}/g;
// RFC 5322 local-parts commonly include `+` for address tags.  Keep the
// validation intentionally conservative while accepting those valid aliases.
export const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const emptyStringRegex = /^( |\n)+$/;
export const videoRegex =
	/[\(\[]?(https?:\/\/[^\s\)\]]*?\.(?:mp4|webm|mov|avi|mkv|flv|wmv|m4v|ogv)(?:\?[^\s\)\]]*)?)[\)\]]?/gi;

export const linkRegex =
	/\[([^\[\]]+)\]\((https?:\/\/[^\s)]+)(?<!\.(?:jpg|jpeg|png|gif|webp|svg))\)/gi;

export const imageRegexWithoutTag =
	/(이미지 url:\s*)(?<!<img\s+src=")(https?:\/\/[^\s"]+\.(?:jpg|jpeg|png|gif|webp)(\?[^\s"]*)?)(?!")/gi;
export const imageRegexWithTag =
	/-? \[이미지 \d+\]\((https?:\/\/.*?\.(?:jpg|jpeg|png|webp|gif|svg|avif))\)/gi;
export const imageRegexWithTag4 =
	/-? \[(이미지 .+)\]\((https?:\/\/.*?\.(?:jpg|jpeg|png|webp|gif|svg|avif))\)/gi;
export const imageRegexWithTag2 =
	/- !\[(.*?)\]\((https?:\/\/.*?\.(?:jpg|jpeg|png|webp|gif|svg|avif))\)/gi;
export const imageRegexWithTag3 =
	/!\[(.*?)\]\((https?:\/\/.*?\.(?:jpg|jpeg|png|webp|gif|svg|avif))\)/gi;
export const imageRegexWithoutImgTag =
	/(?<!<img[^>]*src=["'])(https?:\/\/[^\s]+?\.(?:jpg|jpeg|png|webp|gif|svg|avif))(?!["'][^>]*>)/gi;

export const imageRegexWithBracket =
	/\((https?:\/\/.*?\.(?:jpg|jpeg|png|webp|gif|svg|avif))[^)]*\)/gi;
export const imageRegexDataSrcEmptySrc = /<img([^>]*?)data-src=["']([^"']+)["']([^>]*?)>/gi;
export const imageRegexDataSrcWithoutSrc =
	/<img([^>]*?)data-src=["']([^"']+)["']([^>]*?)src=["']\s*["']([^>]*?)> /gi;
export const imageWithParenthesesRegex = /\(IMG\)\[([^\]]+)\]/g;

export const urlRegexWithWrapper =
	/\[\s*([^\]]+)\s*\]\s*\(\s*(https?:\/\/[^\s)]+(?!\.(jpg|jpeg|png|webp|gif|svg|avif)))\s*\)/gi;
export const urlRegex =
	/(?<!<(img|a)[^>]*?>)\bhttps?:\/\/[^\s<>"]+\b(?<!\.(jpg|jpeg|png|webp|gif|svg|avif))(?=\s|\n)/gi;

export const youtubeEmbedRegex =
	/(?<!src=["'])[\(\[]?https?:\/\/(www\.)?youtube\.com\/embed\/([a-zA-Z0-9_-]+)(?:\?[^\s\)\]]*)?[\)\]]?/g;
export const youtubeRegex =
	/(?<!src=["'])[\(\[]?https?:\/\/(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)(?:[\?&][^\s\)\]]*)?[\)\]]?/g;

export const strongTextRegexWithSpace = /-\s\*\*(.*?)\*\*/gi;
export const strongTextRegexWithBracket = /\[\*\*(.*?)\*\*\]/gi;
export const strongTextRegex = /\*\*(.*?)\*\*/gi;
export const sharpTextRegex = /###(.*?)\n/gi;
export const strongTextTripleCaretRegex = /\^\^\^\s*(.*?)\s*\^\^\^/gi;

export const tableLineBreakPattern = /(<table[\s\S]*?>)([\s\S]*?)(<\/table>)/g;
export const dividerRegex = /---/gi;
export const keyValueRegex = /\n([^:\n]+)\n:/gi;

// 호스트 라벨/TLD에 \p{L}(유니코드 문자)을 허용해 한글 등 비-ASCII IDN 도메인도 통과시킨다.
export const webUrlRegex =
	/^(?:(https?):\/\/)?(?:www\.)?(?:localhost|(?:(?:[\p{L}0-9](?:[\p{L}0-9_-]{0,61}[\p{L}0-9])?\.)+[\p{L}]{2,63})|(?:(?:25[0-5]|2[0-4]\d|1?\d?\d)(?:\.(?:25[0-5]|2[0-4]\d|1?\d?\d)){3}))(?::\d{2,5})?(?:\/[^\s?#]*\/?)?(?:\?[^\s#]*)?(?:#[^\s]*)?$/iu;

export const downloadLinkToSpanRegex =
	/(\^\^\^.*?\^\^\^)(?=[^]*?<a [^>]*?href="([^"]+)"[^>]*?>[^<]*?다운로드[^<]*?<\/a>)/g;

export const externalLinkToSpanRegex =
	/(\^\^\^.*?\^\^\^)(?=[^]*?<a [^>]*?href="([^"]+)"[^>]*?>[^<]*?바로가기[^<]*?<\/a>)/g;
export const preSpaceRegex = /(\n)( +)/gi;

export const downloadRegex =
	/\^\^\^\s*<a\b[^>]*?href\s*=\s*(["'])(.*?)\1[^>]*>\s*\[?([\s\S]*?)\^\^\^\s*\[\s*다운로드\s*링크\s*\]\s*<\/a>/gi;

export const imgPattern = /\[\^\^\^img\](.+?)\s*(?:\(img_size:\s*(.*?)\)\s*)?:\s*(https?:\/\/\S+)/g;
export const linkPattern = /\[\^\^\^link\](.*?)(https?:\/\/\S+)/g;
// export const imgTableUrlPattern = /\[\^\^\^img\]테이블 이미지:\s*(\S+)/i;
